import { FormProvider } from 'contexts/formContext';
import React from 'react';
import { ApproveManualWarranty } from './ApproveManualWarranty';
import {
    defaultvaluesApproveManualWarrantySchema,
    validationSchemaApproveManualWarrantySchema,
} from './ApproveManualWarrantySchema';
import { FieldValues } from 'react-hook-form';
import { useApproveManualWarranty } from 'contexts/creditNote/creditContext';
import { useParams } from 'react-router';
import {
    ApiResponseError,
    ToastType,
    showErrorToast,
    showSuccessToast,
} from 'contexts/apiRequestContext';
import { mapErrorResponse } from 'contexts/responseErrorContext';
import { useGetAvailableReserveTokenByPersonId } from 'contexts/naturalPersonContext';

type ApproveManualWarrantyContainerProps = {
    onClose: () => void;
    personId: string;
    handleAddToken: () => void;
    setToast: React.Dispatch<React.SetStateAction<ToastType>>;
    isNaturalPerson: boolean;
    isNotRequiredFields: boolean;
};

export const ApproveManualWarrantyContainer = ({
    onClose,
    setToast,
    personId,
    handleAddToken,
    isNaturalPerson,
}: ApproveManualWarrantyContainerProps) => {
    const { id } = useParams();
    const { data: tokensList } = useGetAvailableReserveTokenByPersonId(personId!, isNaturalPerson);

    const handleSuccess = () => {
        showSuccessToast('Sucesso ao concluir garantia', '', setToast);
        onClose();
    };

    const handleError = (response: ApiResponseError) => {
        const { errorMessage } = mapErrorResponse(response);
        showErrorToast('Ops, ocorreu um erro', errorMessage, setToast);
    };

    const { mutate } = useApproveManualWarranty(id!, handleSuccess, handleError);

    const onSubmit = (values?: FieldValues) => {
        const tokens = values?.tokens;
        const listTokens = tokens.map((item: any) => {
            return {
                warrantyRegistrationOffice: item.WarrantyRegistrationOffice,
                token: {
                    tokenType: item.Token.TokenType,
                    tokenValue: item.Token.TokenValue,
                },
                warrantyCode: item.warrantyCode,
                expirationDate: item.ExpirationDate,
            };
        });

        const payload = {
            approve: true,
            cancel: false,
            message: values?.justification || '',
            listTokens,
        };
        mutate(payload);
    };

    return (
        <div>
            <FormProvider
                defaultValues={defaultvaluesApproveManualWarrantySchema}
                validationSchema={validationSchemaApproveManualWarrantySchema()}
                onSubmit={onSubmit}
            >
                <ApproveManualWarranty
                    {...{
                        onClose,
                        handleAddToken,
                        tokensList: tokensList ?? [],
                    }}
                />
            </FormProvider>
        </div>
    );
};
